import {Component, EventEmitter, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {AttachmentHandlerView} from "../../attachment-handler/attachment-handler.model";
import {AttachmentService} from "../../../services/attachment.service";

@Component({
    selector: 'app-attachment-element',
    templateUrl: './attachment-element.component.html',
    styleUrls: ['./attachment-element.component.scss']
})
export class AttachmentElementComponent implements OnInit, OnChanges, AttachmentHandlerView {
    @Input() isOptional: boolean;
    @Input() data: any;
    refreshEvent: EventEmitter<any>;

    constructor(private attachmentService:AttachmentService) {
    }

    ngOnInit(): void {
        this.attachmentService.addExtraDataForOne(this.data);
    }

    ngOnChanges(changes: SimpleChanges): void {
    }

}
